import { Col, Row } from "antd";
import DatePickerComponent from "../../../components/DatePickerComponent";
import { InputStyle, labelStyle } from "../constants";
import { useNewsContext } from "../../../context/NewsContext/NewsContext";
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import SwitchOptionComponent from "../../../components/SwitchComponent";
import InputNumberComponent from "../../../components/InputNumberComponent";
import { SwitchContainer } from "./styles";
import { useParams } from "react-router-dom";


const NewsEditInfo = () => {
	const { id } = useParams<{ id: string }>();
	const { newsData, setNewsData, getNewsDetails } = useNewsContext();

	const [releaseDate, setReleaseDate] = useState<string>("");

	const handleReleaseDateChange = (dateString: string) => {
		setReleaseDate(dateString);
		setNewsData({ ...newsData, releaseDate: dateString });
	};

	useEffect(() => {
		if (id) {
			getNewsDetails(id);
		}
	}, [id])


	return (
		<>
			<Row gutter={20}>
				<Col span={8}>
					<InputNumberComponent
						title={"Sıra No"}
						placeholder=""
						isRequired
						style={InputStyle}
						value={newsData?.displayOrder}
						onChange={(value) => setNewsData({ ...newsData, displayOrder: Number(value) })}
					/>
				</Col>
				<Col span={8}>
					<DatePickerComponent
						title="Yayınlanma Tarihi"
						value={newsData?.releaseDate ? dayjs(newsData?.releaseDate) : (releaseDate ? dayjs(releaseDate) : null)}
						onChange={handleReleaseDateChange}
						style={InputStyle}
						isRequired
						disablePastDates={true}
					/>
				</Col>
				<Col span={8}>
					<SwitchContainer>
						<SwitchOptionComponent
							key={"isActive"}
							title={"Görünürlük"}
							labelStyle={labelStyle}
							value={newsData?.isVisible}
							onChange={(checked) => setNewsData({ ...newsData, isVisible: checked })}
						/>
					</SwitchContainer>
				</Col>
			</Row >
		</>
	);
};

export default NewsEditInfo;
